import * as XLSX from 'xlsx';

let loadPromise;

/**
 * Loads public/vendor/spvp-asp-shared.js once and sets window.XLSX for the IIFE.
 * Exposes window.SPVP_ASP (fill helpers, mapping store) used alongside Planning Workspace export flows.
 */
export function ensureSpvpAspScript() {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }

  window.XLSX = XLSX;

  if (window.SPVP_ASP) {
    return Promise.resolve();
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-spvp-asp-shared="1"]');
    if (existing) {
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', () => reject(new Error('spvp-asp-shared.js load error')));
      if (window.SPVP_ASP) resolve();
      return;
    }

    const base = process.env.PUBLIC_URL || '';
    const s = document.createElement('script');
    s.src = `${base.replace(/\/$/, '')}/vendor/spvp-asp-shared.js`;
    s.async = true;
    s.dataset.spvpAspShared = '1';
    s.onload = () => resolve();
    s.onerror = () => reject(new Error(`Failed to load ${s.src}`));
    document.body.appendChild(s);
  });

  return loadPromise;
}
